import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Button } from 'antd';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import './form-button-drop-down.less';

const FormButtonDropDown = (props: any): (ReactElement | null) => {
  const [ showDropdown, toggleDropDown] = useState(false);
  const wrapperRef = useRef(null);

  const formConfig = useGetFormConfig(props);
  const {
    buttonType, isGhost = false, Icon, iconClasses = '',
    key, disabled, options = [], onChange, className = '', showbtnIcon, onDropdownToggle = (): any => {},
  } = formConfig;

  useEffect((): any => {
    onDropdownToggle(showDropdown);
  }, [showDropdown]);

  const useOutsideContainer = (ref: any): void => {
    useEffect((): any => {
      function handleClickOutside(event: any): void {
        if (ref.current && !ref.current.contains(event.target)) {
          toggleDropDown(false);
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return (): any => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideContainer(wrapperRef);

  const optionClickHandler = (value: string, data: any): void => {
    if (onChange) { onChange(value, data); }
    toggleDropDown(!showDropdown);
  };

  return <FormItem formConfig={formConfig}>
    <div
      className="cb-dropdown"
      ref={wrapperRef}
    >
      <Button
        className={className}
        disabled={disabled}
        type={buttonType}
        onClick={(): void => toggleDropDown(!showDropdown)}
        ghost={isGhost}
      >
        {Icon &&
          <Icon
            className={
              iconClasses
              ? `${iconClasses} v-align-middle download-btn-icon`
              : `${showbtnIcon ? 'download-btn-icon' : ''} v-align-middle}`
            }
          />
        }
        {key}
      </Button>
      {showDropdown &&
        <div className="cb-dropdown-content text-left">
          {options && options.length > 0 &&
            options.map((op: any, opIndex: number): ReactElement =>
            <p
              key={opIndex}
              onClick={(): void => optionClickHandler(op.key, op)}
            >
              {op.name}
            </p>)
          }
        </div>
      }
    </div>
  </FormItem>;
};

export default FormButtonDropDown;
